var map = {
	"./blue-avatar.png": 3786,
	"./casual.png": 6886,
	"./clock2.png": 7960,
	"./default.png": 1232,
	"./dianne.png": 7646,
	"./green-avatar.png": 491,
	"./john.png": 231,
	"./kathy.png": 8166,
	"./logo.png": 6949,
	"./man.png": 4612,
	"./maria.png": 6168,
	"./medical.png": 1767,
	"./purple-avatar.png": 9863,
	"./qlementine-icons--user-16.png": 7288,
	"./red-avatar.png": 7250,
	"./ronald.png": 4228,
	"./user.png": 2315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;